import { render, staticRenderFns } from "./open-platform.vue?vue&type=template&id=18956f2a&"
import script from "./open-platform.js?vue&type=script&lang=js&"
export * from "./open-platform.js?vue&type=script&lang=js&"
import style0 from "./open-platform.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports